import React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import chatton1 from '../../assets/chatton1.jpg';
import chatton2 from '../../assets/chatton2.jpg';
import chatton3 from '../../assets/chatton3.jpg';
// import chatton4 from '../../assets/chatton4.jpg';
import chatton5 from '../../assets/chatton5.jpg';
import romy from '../../assets/romy.jpeg';
import chatton8 from '../../assets/chatton8.jpg';
import chatton9 from '../../assets/chatton9.jpg';
import chatton10 from '../../assets/chatton10.jpg';
import chatton18 from '../../assets/chatton18.jpeg';
import chatton12 from '../../assets/chatton12.jpg';
import chatton13 from '../../assets/chatton13.jpg';
import serguei2 from '../../assets/serguei2.jpg';
import serguei3 from '../../assets/serguei3.jpg';
import sato from '../../assets/sato.jpg';
import sato2 from '../../assets/sato2.JPG';
import shannel from '../../assets/shannel.jpg';
import shannel2 from '../../assets/shannel2.jpg';
import shannelSaskia from '../../assets/shannelSaskia.jpg';
import chatton14 from '../../assets/chatton14.jpeg';
import chatton15 from '../../assets/chatton15.jpg';
import chatton16 from '../../assets/chatton16.jpg';
import chat1 from '../../assets/chat1.jpg';
import chat2 from '../../assets/chat2.jpg';
import chat3 from '../../assets/chat3.jpg';
import chat4 from '../../assets/chat4.jpg';
import chat5 from '../../assets/chat5.jpg';
import chat6 from '../../assets/chat6.jpg';
import chat7 from '../../assets/chat7.jpg';
import chat8 from '../../assets/chat8.jpg';
import chat9 from '../../assets/chat9.jpg';
import chat10 from '../../assets/chat10.jpg';
import chat11 from '../../assets/chat11.jpg';
import chatton17 from '../../assets/chatton17.webp';

const itemData = [
  {
    img: chat1,
  },
  {
    img: chat2,
  },
  {
    img: chat3,
  },
  {
    img: chat4,
  },
  {
    img: chat5,
  },
  {
    img: chat6,
  },
  {
    img: chat7,
  },
  {
    img: chat8,
  },
  {
    img: chat9,
  },
  {
    img: chat10,
  },
  {
    img: chat11,
  },
  {
    img: chatton3,
    title: 'Tara',
  },
  {
    img: chatton2,
    title: 'Tips',
  },
  {
    img: chatton5,
    title: 'Thémis',
  },
  {
    img: chatton13,
    title: 'Thor',
  },
  {
    img: chatton8,
    title: 'Thalie',
  },
  {
    img: sato2,
    title: 'Sato',
  },
  {
    img: chatton1,
    title: 'Thanos',
  },
  {
    img: chatton9,
    title: 'Thémis & Tips',
  },
  {
    img: chatton10,
    title: 'Tips',
  },
  {
    img: chatton12,
    title: 'Thor',
  },
  {
    img: serguei2,
    title: 'Serguei',
  },
  {
    img: sato,
    title: 'Sato',
  },
  {
    img: shannel,
    title: 'Shannel Queen',
  },
  {
    img: shannel2,
    title: 'Shannel',
  },
  {
    img: shannelSaskia,
    title: 'Shannel Queen & Saskia',
  },
  {
    img: chatton14,
    title: 'Sherlock',
  },
  {
    img: chatton15,
    title: 'Spike',
  },
  {
    img: chatton16,
    title: 'Snow',
  },
  {
    img: chatton17,
    title: 'Sirius',
  },
  {
    img: serguei3,
    title: 'Serguei',
  },
  {
    img: chatton18,
    title: "Z'Luffy",
  },
  {
    img: romy,
    title: 'Romy',
  },
];

const Galery = () => (
  <ImageList
    sx={{ width: '80%', height: '100%', margin: 'auto' }}
    variant="masonry"
    cols={3}
    gap={8}
  >
    {itemData.map((item) => (
      <ImageListItem key={item.img}>
        <img
          src={`${item.img}?w=161&fit=crop&auto=format`}
          srcSet={`${item.img}?w=161&fit=crop&auto=format&dpr=2 2x`}
          alt={item.title}
          loading="lazy"
        />
        <ImageListItemBar position="below" title={item.title} />
      </ImageListItem>
    ))}
  </ImageList>
);

export default Galery;
